
import { Component, Vue, Prop } from 'vue-property-decorator'
import { commonModule, installationsModule } from '@/store/modules/store-accessor'

@Component
export default class DeleteInstallationPhotoModal extends Vue {
      @Prop()
      payload!: any;
      photoUrl = `${this.payload.photo.base_url}${this.payload.photo.src}`;

      isDeleting = false;

      async mounted() {
          commonModule.initSnackbar({});
      }


      async hideModal() {
          commonModule.hideModal();
      }

      async doDeleteInstallationPhoto() {
          this.isDeleting = true;
          await installationsModule.deleteInstallationPhoto({ installationId: this.payload.photo.installation_id, photoId: this.payload.photo.id });
          await installationsModule.getInstallationDetailsPhotos(this.payload.photo.installation_id);
          await installationsModule.makeInstallationSideviewCommonCalls(String(this.payload.photo.installation_id));
          this.hideModal();
      }
};
